import { ConfirmModalRef } from "$components/modals/ConfirmModal"
import { createRef } from "react"

export const confirmModal = createRef<ConfirmModalRef>()

export const hamburger = createRef<HTMLButtonElement>()
